import React, { useState } from 'react';
import { useAdminTheme } from '../contexts/AdminThemeContext';
import Icon from './AppIcon';

const UserManagement = () => {
  console.log('🚀 UserManagement component initializing');
  const { currentColors } = useAdminTheme();
  const [users, setUsers] = useState([
    {
      id: '1',
      full_name: 'Sanjay Jain',
      email: 'sanjay.jain@bootminds.com',
      company_name: 'Bootminds Elite',
      company_website: 'https://bootminds.com',
      phone: '+1 (555) 123-4567',
      approval_status: 'approved',
      role: 'admin',
      is_admin: true,
      created_at: '2024-01-15T10:30:00.000Z'
    },
    {
      id: '2',
      full_name: 'Swetha Jain',
      email: 'swetha.jain@bootminds.com',
      company_name: 'Bootminds Elite',
      company_website: 'https://bootminds.com',
      phone: '+1 (555) 234-5678',
      approval_status: 'approved',
      role: 'admin',
      is_admin: true,
      created_at: '2024-01-16T09:15:00.000Z'
    },
    {
      id: '3',
      full_name: 'Vandita Rai',
      email: 'vandita.rai@bootminds.com',
      company_name: 'Bootminds Elite',
      company_website: 'https://bootminds.com',
      phone: '+1 (555) 345-6789',
      approval_status: 'approved',
      role: 'admin',
      is_admin: true,
      created_at: '2024-01-17T14:20:00.000Z'
    },
    {
      id: '4',
      full_name: 'Prameela Mallaiah',
      email: 'prameela.mallaiah@bootminds.com',
      company_name: 'Bootminds Elite',
      company_website: 'https://bootminds.com',
      phone: '+1 (555) 456-7890',
      approval_status: 'approved',
      role: 'admin',
      is_admin: true,
      created_at: '2024-01-18T11:45:00.000Z'
    },
    {
      id: '5',
      full_name: 'John Smith',
      email: 'john.smith@techcorp.com',
      company_name: 'TechCorp Solutions',
      company_website: 'https://techcorp.com',
      phone: '+1 (555) 567-8901',
      approval_status: 'approved',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-01T08:30:00.000Z'
    },
    {
      id: '6',
      full_name: 'Sarah Johnson',
      email: 'sarah.johnson@innovatecorp.com',
      company_name: 'InnovateCorp',
      company_website: 'https://innovatecorp.com',
      phone: '+1 (555) 678-9012',
      approval_status: 'approved',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-05T13:15:00.000Z'
    },
    {
      id: '7',
      full_name: 'Michael Chen',
      email: 'michael.chen@datacorp.com',
      company_name: 'DataCorp Analytics',
      company_website: 'https://datacorp.com',
      phone: '+1 (555) 789-0123',
      approval_status: 'pending',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-10T16:45:00.000Z'
    },
    {
      id: '8',
      full_name: 'Emily Davis',
      email: 'emily.davis@globaltech.com',
      company_name: 'GlobalTech Systems',
      company_website: 'https://globaltech.com',
      phone: '+1 (555) 890-1234',
      approval_status: 'pending',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-12T10:20:00.000Z'
    },
    {
      id: '9',
      full_name: 'David Wilson',
      email: 'david.wilson@fintech.com',
      company_name: 'FinTech Innovations',
      company_website: 'https://fintech.com',
      phone: '+1 (555) 901-2345',
      approval_status: 'approved',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-15T12:30:00.000Z'
    },
    {
      id: '10',
      full_name: 'Lisa Brown',
      email: 'lisa.brown@cloudservices.com',
      company_name: 'CloudServices Pro',
      company_website: 'https://cloudservices.com',
      phone: '+1 (555) 012-3456',
      approval_status: 'approved',
      role: 'user',
      is_admin: false,
      created_at: '2024-02-18T15:10:00.000Z'
    }
  ]);
  const [showAddAdminModal, setShowAddAdminModal] = useState(false);
  const [newAdminEmail, setNewAdminEmail] = useState('');
  const [adminRole, setAdminRole] = useState('admin');
  const [processing, setProcessing] = useState(false);
  const [loginType, setLoginType] = useState('email'); // 'email' or 'github'
  const [githubUsername, setGithubUsername] = useState('');

  const addAdminAccess = async () => {
    console.log('🚀 Starting add admin access process');

    // Validate based on login type
    if (loginType === 'email' && !newAdminEmail) {
      console.log('❌ No email provided');
      alert('Please enter an email address');
      return;
    }

    if (loginType === 'github' && !githubUsername) {
      console.log('❌ No GitHub username provided');
      alert('Please enter a GitHub username');
      return;
    }

    const targetEmail = loginType === 'email' ? newAdminEmail : `${githubUsername}@github.local`;
    const targetUsername = loginType === 'github' ? githubUsername : '';

    console.log('📧 Processing admin access for:', targetEmail);
    console.log('👑 Admin role selected:', adminRole);
    console.log('🔐 Login type:', loginType);

    try {
      setProcessing(true);

      // Check if user already exists
      const existingUser = users.find(u => u.email === targetEmail);
      if (existingUser) {
        console.log('⚠️ User already exists:', existingUser.full_name);
        alert(`User ${targetEmail} already exists in the system.`);
        setNewAdminEmail('');
        setGithubUsername('');
        setShowAddAdminModal(false);
        return;
      }

      console.log('👤 Creating new admin user');

      // Generate auto-password for email users
      const autoPassword = loginType === 'email' ? generateAutoPassword() : null;

      // Create new admin user
      const newUser = {
        id: `user-${Date.now()}`,
        full_name: loginType === 'email'
          ? newAdminEmail.split('@')[0].replace('.', ' ').replace(/\b\w/g, l => l.toUpperCase())
          : githubUsername.replace(/[^a-zA-Z0-9]/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        email: targetEmail,
        github_username: targetUsername,
        company_name: 'Bootminds Elite',
        company_website: 'https://bootminds.com',
        phone: '',
        approval_status: 'approved',
        role: adminRole,
        is_admin: true,
        login_type: loginType,
        auto_generated_password: autoPassword,
        created_at: new Date().toISOString()
      };

      console.log('✅ New admin user created:', newUser.full_name);
      setUsers(prev => [newUser, ...prev]);
      console.log('✅ Admin user added to users list');

      // Show different messages based on login type
      if (loginType === 'email') {
        alert(`Admin access granted to ${newAdminEmail} successfully!\n\nAuto-generated password: ${autoPassword}\n\nPlease share this password with the user for their first login.`);
        console.log('🔑 Auto-generated password:', autoPassword);
      } else {
        alert(`Admin access granted to GitHub user @${githubUsername} successfully!\n\nThe user can now log in using their GitHub account.`);
      }

      setNewAdminEmail('');
      setGithubUsername('');
      setShowAddAdminModal(false);
      console.log('🧹 Modal closed and form reset');
    } catch (error) {
      console.error('❌ Error adding admin:', error);
      alert('Error adding admin: ' + error.message);
    } finally {
      setProcessing(false);
      console.log('🔄 Processing state reset');
    }
  };

  // Generate secure auto-password
  const generateAutoPassword = () => {
    const length = 12;
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let password = '';

    // Ensure at least one of each type
    password += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]; // uppercase
    password += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)]; // lowercase
    password += '0123456789'[Math.floor(Math.random() * 10)]; // number
    password += '!@#$%^&*'[Math.floor(Math.random() * 8)]; // special

    // Fill remaining length
    for (let i = 4; i < length; i++) {
      password += charset[Math.floor(Math.random() * charset.length)];
    }

    // Shuffle the password
    return password.split('').sort(() => Math.random() - 0.5).join('');
  };

  const toggleAdminStatus = async (userId, currentStatus) => {
    try {
      if (currentStatus) {
        // Remove admin access
        setUsers(prev => prev.map(user =>
          user.id === userId
            ? { ...user, role: 'user', is_admin: false }
            : user
        ));
        alert('Admin access revoked');
      } else {
        // Grant admin access
        setUsers(prev => prev.map(user =>
          user.id === userId
            ? { ...user, role: 'admin', is_admin: true }
            : user
        ));
        alert('Admin access granted');
      }
    } catch (error) {
      console.error('Error updating admin status:', error);
      alert('Error updating admin status: ' + error.message);
    }
  };

  const getSubscriptionStatus = (user) => {
    // For now, return basic status based on approval
    if (user.approval_status === 'approved') {
      return 'Basic';
    } else if (user.approval_status === 'pending') {
      return 'Pending';
    } else {
      return 'Free';
    }
  };

  const isAdmin = (user) => {
    // For now, check if user has admin role in metadata
    return user.role === 'admin' || user.is_admin === true;
  };


  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold" style={{ color: currentColors.text }}>
            User Management
          </h2>
          <p className="text-sm mt-1" style={{ color: currentColors.textMuted }}>
            Manage user accounts, subscriptions, and admin access
          </p>
        </div>
        <button
          onClick={() => setShowAddAdminModal(true)}
          className="px-4 py-2 rounded-lg font-medium transition-all duration-200 hover:opacity-90"
          style={{ backgroundColor: currentColors.primary, color: '#ffffff' }}
        >
          <Icon name="UserPlus" size={16} className="inline mr-2" />
          Add Admin Access
        </button>
      </div>

      {/* User Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        {[
          { label: 'Total Users', value: users.length, icon: 'Users', color: currentColors.primary },
          { label: 'Active Admins', value: users.filter(isAdmin).length, icon: 'Shield', color: currentColors.success },
          { label: 'Premium Users', value: users.filter(u => getSubscriptionStatus(u) !== 'Free').length, icon: 'Crown', color: currentColors.warning },
          { label: 'New This Month', value: users.filter(u => new Date(u.created_at) > new Date(Date.now() - 30*24*60*60*1000)).length, icon: 'TrendingUp', color: currentColors.info }
        ].map((stat, index) => (
          <div 
            key={index}
            className="p-6 rounded-xl border"
            style={{ backgroundColor: currentColors.surface, borderColor: currentColors.border }}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  {stat.label}
                </p>
                <p className="text-2xl font-bold mt-1" style={{ color: currentColors.text }}>
                  {stat.value}
                </p>
              </div>
              <div 
                className="w-12 h-12 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${stat.color}20` }}
              >
                <Icon name={stat.icon} size={24} style={{ color: stat.color }} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Users Table */}
      <div 
        className="rounded-xl shadow-sm border overflow-hidden"
        style={{ backgroundColor: currentColors.surface, borderColor: currentColors.border }}
      >
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead style={{ backgroundColor: currentColors.background }}>
              <tr>
                <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  User
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  Company
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  Login Type
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  Role
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: currentColors.textSecondary }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="border-t" style={{ borderColor: currentColors.border }}>
                  <td className="px-6 py-4">
                    <div>
                      <p className="font-medium" style={{ color: currentColors.text }}>
                        {user.full_name || 'Unknown User'}
                      </p>
                      <p className="text-sm" style={{ color: currentColors.textMuted }}>
                        {user.email || 'No email provided'}
                      </p>
                      <p className="text-xs" style={{ color: currentColors.textMuted }}>
                        Joined {new Date(user.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div>
                      <p className="font-medium" style={{ color: currentColors.text }}>
                        {user.company_name || 'No company'}
                      </p>
                      {user.company_website && (
                        <a 
                          href={user.company_website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-sm hover:underline"
                          style={{ color: currentColors.primary }}
                        >
                          Visit website
                        </a>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      {user.login_type === 'github' ? (
                        <>
                          <Icon name="Github" size={14} style={{ color: currentColors.textSecondary }} />
                          <span className="text-sm" style={{ color: currentColors.textSecondary }}>
                            GitHub
                          </span>
                          {user.github_username && (
                            <span className="text-xs" style={{ color: currentColors.textMuted }}>
                              @{user.github_username}
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          <Icon name="Mail" size={14} style={{ color: currentColors.textSecondary }} />
                          <span className="text-sm" style={{ color: currentColors.textSecondary }}>
                            Email
                          </span>
                        </>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className="px-2 py-1 rounded-full text-xs font-medium"
                      style={{
                        backgroundColor: getSubscriptionStatus(user) === 'Free' ? `${currentColors.textMuted}20` : `${currentColors.success}20`,
                        color: getSubscriptionStatus(user) === 'Free' ? currentColors.textMuted : currentColors.success
                      }}
                    >
                      {getSubscriptionStatus(user)}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <span 
                        className="px-2 py-1 rounded-full text-xs font-medium"
                        style={{
                          backgroundColor: isAdmin(user) ? `${currentColors.primary}20` : `${currentColors.textMuted}20`,
                          color: isAdmin(user) ? currentColors.primary : currentColors.textMuted
                        }}
                      >
                        {isAdmin(user) ? 'Admin' : 'User'}
                      </span>
                      {isAdmin(user) && (
                        <Icon name="Shield" size={14} style={{ color: currentColors.primary }} />
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => toggleAdminStatus(user.id, isAdmin(user))}
                      className="px-3 py-1 rounded-lg text-sm font-medium transition-all duration-200 hover:opacity-80"
                      style={{
                        backgroundColor: isAdmin(user) ? `${currentColors.error}20` : `${currentColors.primary}20`,
                        color: isAdmin(user) ? currentColors.error : currentColors.primary
                      }}
                    >
                      {isAdmin(user) ? 'Revoke Admin' : 'Grant Admin'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Admin Modal */}
      {showAddAdminModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div 
            className="bg-card rounded-xl p-6 w-full max-w-md mx-4"
            style={{ backgroundColor: currentColors.surface }}
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold" style={{ color: currentColors.text }}>
                Add Admin Access
              </h3>
              <button 
                onClick={() => setShowAddAdminModal(false)}
                className="p-2 rounded-lg hover:bg-opacity-10 hover:bg-muted-foreground"
              >
                <Icon name="X" size={20} style={{ color: currentColors.text }} />
              </button>
            </div>

            <div className="space-y-4">
              {/* Login Type Selection */}
              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                  Login Type *
                </label>
                <div className="flex gap-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="loginType"
                      value="email"
                      checked={loginType === 'email'}
                      onChange={(e) => setLoginType(e.target.value)}
                      className="mr-2"
                    />
                    <span style={{ color: currentColors.text }}>Email & Password</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="loginType"
                      value="github"
                      checked={loginType === 'github'}
                      onChange={(e) => setLoginType(e.target.value)}
                      className="mr-2"
                    />
                    <span style={{ color: currentColors.text }}>GitHub Account</span>
                  </label>
                </div>
              </div>

              {/* Conditional Input Fields */}
              {loginType === 'email' ? (
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    value={newAdminEmail}
                    onChange={(e) => setNewAdminEmail(e.target.value)}
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring-2"
                    style={{
                      backgroundColor: currentColors.background,
                      borderColor: currentColors.border,
                      color: currentColors.text
                    }}
                    placeholder="Enter email address..."
                  />
                  <p className="text-xs mt-1" style={{ color: currentColors.textSecondary }}>
                    A secure password will be auto-generated for this user
                  </p>
                </div>
              ) : (
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                    GitHub Username *
                  </label>
                  <div className="flex">
                    <span className="inline-flex items-center px-3 py-2 border border-r-0 rounded-l-lg bg-muted/50" style={{ color: currentColors.textSecondary }}>
                      @
                    </span>
                    <input
                      type="text"
                      value={githubUsername}
                      onChange={(e) => setGithubUsername(e.target.value)}
                      className="flex-1 px-4 py-2 border rounded-r-lg focus:outline-none focus:ring-2"
                      style={{
                        backgroundColor: currentColors.background,
                        borderColor: currentColors.border,
                        color: currentColors.text
                      }}
                      placeholder="Enter GitHub username..."
                    />
                  </div>
                  <p className="text-xs mt-1" style={{ color: currentColors.textSecondary }}>
                    User will log in using their GitHub account
                  </p>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium mb-2" style={{ color: currentColors.text }}>
                  Admin Role
                </label>
                <select
                  value={adminRole}
                  onChange={(e) => setAdminRole(e.target.value)}
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring-2"
                  style={{ 
                    backgroundColor: currentColors.background, 
                    borderColor: currentColors.border,
                    color: currentColors.text
                  }}
                >
                  <option value="admin">Admin</option>
                  <option value="editor">Editor</option>
                  <option value="moderator">Moderator</option>
                </select>
              </div>

              <div 
                className="p-4 rounded-lg border"
                style={{ backgroundColor: currentColors.background, borderColor: currentColors.border }}
              >
                <h4 className="font-medium mb-2" style={{ color: currentColors.text }}>
                  Admin Permissions:
                </h4>
                <ul className="text-sm space-y-1" style={{ color: currentColors.textSecondary }}>
                  <li>• Manage content (blogs, resources, webinars)</li>
                  <li>• View analytics and user data</li>
                  <li>• Moderate user accounts</li>
                  <li>• Access admin dashboard</li>
                </ul>
              </div>
            </div>

            <div className="flex gap-3 justify-end mt-6">
              <button
                onClick={() => setShowAddAdminModal(false)}
                className="px-4 py-2 rounded-lg font-medium transition-all duration-200"
                style={{ backgroundColor: currentColors.border, color: currentColors.text }}
              >
                Cancel
              </button>
              <button
                onClick={addAdminAccess}
                disabled={processing || (loginType === 'email' ? !newAdminEmail : !githubUsername)}
                className="px-4 py-2 rounded-lg font-medium transition-all duration-200 disabled:opacity-50 flex items-center"
                style={{ backgroundColor: currentColors.primary, color: '#ffffff' }}
              >
                {processing ? (
                  <>
                    <Icon name="Loader2" size={16} className="animate-spin mr-2" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Icon name="UserPlus" size={16} className="mr-2" />
                    Add Admin
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
